<template>
  <div class="container old-globals">
    <case-build-assistant-container @added="onCaseAdded" @close="onCaseClosed" />
  </div>
</template>

<script>
import CaseBuildAssistantContainer from '../containers/CaseBuildAssistant';

export default {
  name: 'case-builder-screen',
  components: {
    CaseBuildAssistantContainer,
  },
  methods: {
    onCaseAdded(id) {
      this.$router.push({ name: 'case-editor', params: { id } });
    },
    onCaseClosed() {
      if (this.fromPath !== '/cases') {
        this.$router.push({ name: 'cases' });
      } else {
        this.$router.go(-1);
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // eslint-disable-next-line no-param-reassign
      vm.fromPath = from.fullPath;
    });
  },
};
</script>

<style scoped>
.container {
  height: 100%;
}
</style>
